import React from 'react';
import { Mail, Phone, MapPin, Facebook, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

export default function Footer({ brand }) {

  return (
    <footer className="text-white" style={{ background: '#0d1b2e' }}>
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-8">

          <div>
            <Logo logoUrl={brand?.logo_url} variant="footer" />

            <p className="mt-4 text-sm" style={{ color: 'rgba(255,255,255,0.55)' }}>
              Votre partenaire de confiance pour des réservations hôtelières en Tunisie avec les meilleurs tarifs B2B.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Liens rapides</h3>
            <ul className="space-y-2 text-sm" style={{ color: 'rgba(255,255,255,0.55)' }}>
              <li><a href="#" className="hover:text-white transition">À propos</a></li>
              <li><a href="#" className="hover:text-white transition">Nos services</a></li>
              <li><a href="#" className="hover:text-white transition">Destinations</a></li>
              <li><a href="#" className="hover:text-white transition">Conditions générales</a></li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contact</h3>
            <ul className="space-y-3 text-sm" style={{ color: 'rgba(255,255,255,0.55)' }}>
              <li className="flex items-center gap-2">
                <Phone size={16} style={{ color: '#e84545' }} />
                <span>{brand?.tel || "+216 28 233 243"}</span>
              </li>
              <li className="flex items-center gap-2">
                <Mail size={16} style={{ color: '#FF7B47' }} />
                <span>{brand?.email || "booking@216-booking.com"}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={16} style={{ color: '#e84545', marginTop: '2px' }} />
                <span>{brand?.adresse || "Marina, Djerba Houmt Souk"}</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Suivez-nous</h3>
            <div className="flex gap-3">
<a 
  href="https://www.facebook.com/216.booking"
  target="_blank"
  rel="noopener noreferrer"
  className="p-3 rounded-lg transition"
  style={{ 
    background: 'rgba(232,69,69,0.12)', 
    border: '0.5px solid rgba(232,69,69,0.3)' 
  }}
  onMouseEnter={e => e.currentTarget.style.background='#e84545'}
  onMouseLeave={e => e.currentTarget.style.background='rgba(232,69,69,0.12)'}
>
  <Facebook size={20} />
</a>
              <a href="#" className="p-3 rounded-lg transition" style={{ background: 'rgba(255,123,71,0.12)', border: '0.5px solid rgba(255,123,71,0.3)' }}
                onMouseEnter={e => e.currentTarget.style.background='#FF7B47'}
                onMouseLeave={e => e.currentTarget.style.background='rgba(255,123,71,0.12)'}>
                <Instagram size={20} />
              </a>
              <a href="#" className="p-3 rounded-lg transition" style={{ background: 'rgba(232,69,69,0.12)', border: '0.5px solid rgba(232,69,69,0.3)' }}
                onMouseEnter={e => e.currentTarget.style.background='#e84545'}
                onMouseLeave={e => e.currentTarget.style.background='rgba(232,69,69,0.12)'}>
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-6 text-center text-sm" style={{ borderTop: '0.5px solid rgba(232,69,69,0.2)', color: 'rgba(255,255,255,0.3)' }}>
          © {new Date().getFullYear()} {brand?.libelle || "216-Booking"}. Tous droits réservés.

        </div>
      </div>
    </footer>
  );
}